import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Layout from "../../page/layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import { Button, Card, Container, Row, Col, Spinner } from "react-bootstrap";
import { IoAddCircle } from "react-icons/io5";

const PetaniLahan = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [userData, setUserData] = useState([]);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin"  && user.role !== "perusahaan" && user.role !== "petani") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");

      try {
        const response = await axios.get(
          `https://c-greenproject.org:8000/getpetanidasar`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setUserData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (user?.uuid) {
      fetchData();
    }
  }, [user?.uuid]);

  const deleteLahan = async (id) => {
    if (window.confirm("Apakah Anda yakin ingin menghapus data ini?")) {
      const token = localStorage.getItem("token");

      try {
        await axios.delete(`https://c-greenproject.org:8000/petani/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const updatedUserData = userData.filter((data) => data.id !== id);
        setUserData(updatedUserData);
        alert("Data berhasil dihapus.");
      } catch (error) {
        console.error("Error deleting data:", error);
        alert("Terjadi kesalahan saat menghapus data.");
      }
    }
  };

  return (
    <Layout>
      <Container>
        <h2 className="mb-4">
          <strong>Data Lahan Petani</strong>
        </h2>

        {user && (user.role === "admin" || user.role === "petani") && (
          <Link to="/datalahan/add">
            <Button variant="primary" className="mb-3">
              <IoAddCircle /> Tambah Data Lahan Petani
            </Button>
          </Link>
        )}

        {userData.length ? (
          userData.map((data, index) => (
            <Card key={index} className="mb-4 shadow-sm">
              <Card.Body>
                {/* Informasi Petani */}
                {user &&
                  (user.role === "admin" || user.role === "perusahaan") && (
                    <Row className="mb-3">
                      <Col md={6}>
                        <Row>
                          <Col md={4} className="fw-bold">
                            Nama Petani
                          </Col>
                          <Col md={8}>{data.user.name}</Col>
                        </Row>
                        <Row>
                          <Col md={4} className="fw-bold">
                            Email Petani
                          </Col>
                          <Col md={8}>{data.user.email}</Col>
                        </Row>
                      </Col>
                    </Row>
                  )}

                {/* Informasi Lahan */}
                <h5 className="fw-bold">1. Informasi Lahan</h5>
                <Row>
                  <Col md={4} className="mb-1">
                    ID Lahan
                  </Col>
                  <Col md={8}>{data.idlahan}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1">
                    Lokasi Lahan
                  </Col>
                  <Col md={8}>{data.lokasilahan}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1">
                    Luas Lahan
                  </Col>
                  <Col md={8}>{data.luaslahan}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1">
                    Kategori Lahan
                  </Col>
                  <Col md={8}>{data.kategorilahan}</Col>
                </Row>
                {data.kategorilahan === "Inti" && (
                  <Row>
                    <Col md={4} className="mb-1">
                      Nama Perusahaan
                    </Col>
                    <Col md={8}>{data.namePerusahaan || "Tidak Ada"}</Col>
                  </Row>
                )}

                {/* Data Produksi */}
                <h5 className="fw-bold mt-3">2. Data Produksi</h5>
                <Row>
                  <Col md={4} className="mb-1">
                    Periode Tanam Mulai
                  </Col>
                  <Col md={8}>{data.periodeTanamMulai}</Col>
                </Row>
                <Row>
                  <Col md={4} className="mb-1">
                    Periode Tanam Selesai
                  </Col>
                  <Col md={8}>{data.periodeTanamSelesai}</Col>
                </Row>

                {/* Tombol Hapus */}
                {user && user.role === "admin" && (
                  <Button
                    variant="danger"
                    onClick={() => deleteLahan(data.id)}
                    className="mt-3"
                  >
                    Hapus
                  </Button>
                )}
              </Card.Body>
            </Card>
          ))
        ) : (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
            <p>Memuat data...</p>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default PetaniLahan;
